import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import MDBox from 'components/MDBox'
import breakpoints from 'assets/theme/base/breakpoints'
import Loader from 'examples/Loader'

const iframeStyles = {
  width: '100%',
  height: 'calc(100vh - 100px)',
  border: 'none',
}

function TabsHeader({ pages, appData, snapshotData, ssodata, app_id }) {
  const [tabsOrientation, setTabsOrientation] = useState('horizontal')
  const [tabValue, setTabValue] = useState(0)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation('vertical')
        : setTabsOrientation('horizontal')
    }

    window.addEventListener('resize', handleTabsOrientation)
    handleTabsOrientation()
    return () => window.removeEventListener('resize', handleTabsOrientation)
  }, [])

  const handleSetTabValue = (index) => {
    setTabValue(index)
    setLoading(true) // Reset loading when tab changes
  }
  let iframeSrc = null





  if (pages?.[tabValue]?.linkType === 'Pre Defined') {
    const page = pages?.[tabValue]?.page

    if (page === 'Knowledge Base') {
      iframeSrc = `https://knowledgebaseapp.levelupmarketplace.io/snapshot/${appData?.main_app_id}/${appData?.company_id}/free_plan/${appData?.snapshot_ref_id}/documents`
    } else if (page === 'Road Map') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/roadmap/${app_id}`
    } else if (page === 'Change Logs') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/changelogs/${app_id}`
    } else if (page === 'Form Link' && ssodata?.activeLocation) {
      iframeSrc = `https://snapshotonboarding.levelupmarketplace.io/levelupstore/${appData?.company_id}/${appData?.main_app_id}/${ssodata?.activeLocation}/${snapshotData?.form_id}/preview`
    } else if (page === 'Media Library') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/media_library/${app_id}`
    } else if (page === 'Onboard List') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/onboard_list/${app_id}`
    } else if (page === 'Checklist') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/checklist/${app_id}`
      // }else if (page === 'Change Logs') {
      //   iframeSrc = `https://appcreator.alltheapps.io/app/company_id/${appData?.main_app_id}/changelogs/${app_id}`
    } else if (page === 'Roadmap') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/roadmap/${app_id}`
    } else if (page === 'Quiz') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/quiz/${app_id}`
    } else if (page === 'Service Store') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/service_store/${app_id}`
    } else if (page === 'Submit Ticket') {
      // iframeSrc = `http://localhost:3034/${appData?.company_id}/${appData?.main_app_id}/support/${app_id}/mIUnQuoHIx0KVvg1ppWc?userName=Abdul Rehman&email=Rehman@levelupmarketplace.com`

      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/support/${app_id}/${ssodata?.userId}?username=${ssodata?.userName}&email=${ssodata?.email}&user_company=${ssodata?.companyId}&user_location=${ssodata?.activeLocation}`
    } else if (page === 'News Feeds') {
      iframeSrc = `https://appcreator.alltheapps.io/${appData?.company_id}/${appData?.main_app_id}/newsfeed/${app_id}`
    }
  } else {
    const rawLink = pages?.[tabValue]?.templateLink || '';
    iframeSrc = rawLink
      .replace('{{company.Id}}', ssodata?.companyId || '')
      .replace('{{location.Id}}', ssodata?.activeLocation || '')
      .replace('{{user.Id}}', ssodata?.userId || '')
      .replace('{{email}}', ssodata?.email || '')
      .replace('{{plan.Id}}', ssodata?.planId || '');
    console.log("iframeSrc", iframeSrc, rawLink)
  }
  return (
    <MDBox>
      <header
        style={{
          position: 'sticky',
          top: 0,
          boxShadow: '0 2px 3px rgba(0,0,0,.11)',
          height: '70px',
          backgroundColor: '#fff',
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          zIndex: 1000,
        }}
      >
        <nav style={{ width: '100%' }}>
          <ul
            style={{
              listStyle: 'none',
              display: 'flex',
              margin: 0,
              padding: 0,
              fontSize: '14.5px',
              fontWeight: 400,
            }}
          >
            {pages?.map((page, index) =>
              page.linkType == 'Pre Defined' &&
                page.page == 'Form Link' &&
                !ssodata?.activeLocation ? (
                <></>
              ) : (
                <li
                  key={index}
                  style={{
                    padding: '10px 15px',
                    cursor: 'pointer',
                    transition: 'color 0.3s',
                  }}
                  onClick={() => handleSetTabValue(index)}
                >
                  <a
                    style={{
                      textDecoration: 'none',
                      color: index === tabValue ? '#188bf6' : '#333',
                    }}
                  >
                    {page?.page}
                  </a>
                </li>
              )
            )}
          </ul>
        </nav>
      </header>

      <MDBox mt={1} position="relative">
        {loading && <Loader />}
        {iframeSrc && (
          <iframe src={iframeSrc} style={iframeStyles} onLoad={() => setLoading(false)} />
        )}
      </MDBox>
    </MDBox>
  )
}

TabsHeader.propTypes = {
  pages: PropTypes.array.isRequired,
}

export default TabsHeader
